import { render, staticRenderFns } from "./SingleRecordNavMenuComp.vue?vue&type=template&id=68d27280&"
import script from "./SingleRecordNavMenuComp.vue?vue&type=script&lang=js&"
export * from "./SingleRecordNavMenuComp.vue?vue&type=script&lang=js&"
import style0 from "./SingleRecordNavMenuComp.vue?vue&type=style&index=0&id=68d27280&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports